"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Button = __importStar(require("./A_Button"));
var toDirection = function (orientation) {
    return orientation === 'vertical' ? 'column' : 'row';
};
/** Represents two CTA buttons designs to be rendered together, one primary and one secondary */
var Component = function (p) {
    var _a;
    return (Preact.h(Box_1.default, { display: "flex", flexDirection: toDirection(p.orientation), sx: { gap: '8px' } },
        Preact.h(Button.Component, { variant: "contained", color: "primary", size: p.size, onClick: p.primaryOnClick, disabled: p.disabled }, p.primaryCopy),
        p.secondaryOnClick && (Preact.h(Button.Component, { variant: (_a = p.secondaryVariant) !== null && _a !== void 0 ? _a : 'outlined', color: "secondary", size: p.size, onClick: p.secondaryOnClick, disabled: p.disabled }, p.secondaryCopy))));
};
exports.Component = Component;
